import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputMask from "react-input-mask";

import UI from "../../actions/ui-helper";
import API from "../../actions/api-helper";
import DataUtil from "../../actions/data.js";

class CadastroLancamento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lancamento: this.getInitialState(),
      categorias: [],
      pronto: false,
    };
    if (this.props.match.params.id) {
      this.state.lancamento.id = this.props.match.params.id;
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = UI.handleChange.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
  }

  getInitialState() {
    return {
      id: 0,
      data: DataUtil.hoje(),
      categoria: { id: 0 },
      envolvido: "",
      descricao: "",
      valor: "0.00",
      periodicidade: "A_VISTA",
      quitado: false,
    };
  }

  componentDidUpdate() {
    UI.inputHelpers();
  }

  componentDidMount() {
    UI.inputHelpers();

    UI.loader("show", "Buscando categorias...");
    API.get("/financeiro/categorias")
      .then((json) => {
        let pronto = json.data.length > 0;
        if (!pronto) {
          UI.alert(true, "Nenhuma categoria financeira cadastrada.", "info");
        } else {
          let lanca = this.state.lancamento;
          lanca.categoriaId = json.data[0].id;
          lanca.categoria = json.data[0];
          this.setState({ categorias: json.data, pronto: pronto });
        }
        UI.loader("hide");
      })
      .catch((json) => {
        UI.alert(false, json.message);
        UI.loader("hide");
      });

    // Verifica se vem de uma rota com id
    let id = parseInt(this.state.lancamento.id);
    if (id !== 0) {
      UI.loader("show", "Um momento...");
      API.get("/financeiro/lancamentos/" + id)
        .then((json) => {
          json.data.categoriaId = json.data.categoria.id;
          this.setState({ lancamento: json.data, pronto: true });
          UI.loader("hide");
        })
        .catch(function (json) {
          UI.alert(false, json.message);
          UI.loader("hide");
        });
    }
  }

  handleChecked(event) {
    let lancamento = this.state.lancamento;
    lancamento[event.target.name] = event.target.checked;
    this.setState({ lancamento: lancamento });
  }

  handleSubmit(event) {
    event.preventDefault();

    // Validação dos campos (temporario)
    let data = this.state.lancamento;
    if (data.descricao.length < 3) {
      UI.alert(false, "Descrição é obrigatório.");
      return;
    }

    UI.loader("show", "Um momento...");
    API.post("/financeiro/lancamentos", data)
      .then(
        function (json) {
          json.data.categoriaId = json.data.categoria.id;
          this.setState({ lancamento: json.data });
          UI.alert(json.success, json.message);
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  render() {
    if (!this.state.pronto) return false;

    // Corrigir o objeto selecionado na categoria do lancamento
    let lanca = this.state.lancamento;
    lanca.categoria = this.state.categorias.find((c) => {
      console.log(c);
      return c.id === parseInt(lanca.categoriaId);
    });

    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="form-group row">
                  <div className="col-md-11">
                    {this.state.lancamento.id === 0 && (
                      <h4 className="card-title">NOVO LANÇAMENTO</h4>
                    )}
                    {this.state.lancamento.id !== 0 && (
                      <h4 className="card-title">
                        CADASTRO DO LANÇAMENTO #{this.state.lancamento.id}
                      </h4>
                    )}
                  </div>
                  <div className="col-md-1 align-top">
                    <label></label>
                    <div className="form-check form-check-success">
                      <label className="form-check-label">
                        <input
                          name="lancamento.quitado"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.lancamento.quitado}
                          onChange={this.handleChecked}
                        />
                        Quitado
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-2">
                    <label>Data *</label>
                    <InputMask
                      placeholder="DATA"
                      name="lancamento.data"
                      className="form-control"
                      mask="99/99/9999"
                      value={this.state.lancamento.data}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Categoria *</label>
                    <select
                      name="lancamento.categoriaId"
                      className="form-control"
                      value={this.state.lancamento.categoriaId}
                      onChange={this.handleChange}
                    >
                      {this.state.categorias.map((cat, i) => {
                        return (
                          <option key={i} value={cat.id}>
                            {cat.nome}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Pagador/Beneficiário</label>
                    <input
                      placeholder="NOME DO ENVOLVIDO"
                      autoFocus
                      name="lancamento.envolvido"
                      type="text"
                      className="form-control"
                      value={this.state.lancamento.envolvido}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Valor (R$) *</label>
                    <input
                      type="number"
                      step="any"
                      name="lancamento.valor"
                      value={this.state.lancamento.valor}
                      onChange={this.handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-8">
                    <label>Descrição *</label>
                    <input
                      placeholder="DESCRIÇÃO DO LANÇAMENTO"
                      autoFocus
                      name="lancamento.descricao"
                      type="text"
                      className="form-control"
                      value={this.state.lancamento.descricao}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Periodicidade *</label>
                    <select
                      disabled
                      name="lancamento.periodicidade"
                      className="form-control"
                      value={this.state.lancamento.periodicidade}
                      onChange={this.handleChange}
                    >
                      <option value="A_VISTA">À VISTA</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 text-right">
                    <button type="submit" className="btn btn-success mb-2">
                      Concluido
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default withRouter(CadastroLancamento);
